export default {
  unknown: 'Unknown',
  generic_error: 'Ha ocurrido un error',
};
